import gql from 'graphql-tag';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class BodegaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetBodegas(rutEmpresa, sucursalCodigo, callback) {
        this.gqlclient.query({
            query: gql `
        query(
            $rut_empresa: Decimal,
            $sucursal_codigo: Decimal
          )
          {
          bodega {
            obtenerSegunFiltro (
              filtro: {
                exacto: {
                  rut_empresa: $rut_empresa,
                  sucursal_codigo: $sucursal_codigo,
                  tipobusqueda: 1
                }
              })
              {
                respuesta{
                  registros{
                    nombre
                    codigo
                    descripcion
                    sucursal_codigo
                    principal
                  }
                }
            }
          }
        }
        `,
            variables: {
                rut_empresa: rutEmpresa,
                sucursal_codigo: sucursalCodigo
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            let { mensajes, respuesta } = _.cloneDeep(response.data.bodega.obtenerSegunFiltro);
            let { registros } = respuesta;
            if (respuesta && respuesta.registros) {
                registros = _.orderBy(registros, ['principal', 'nombre'], ['desc', 'asc']);
                registros.map(bodega => {
                    if (bodega.principal) {
                        bodega.nombre = `${bodega.nombre} (PRINCIPAL)`;
                    }
                });
            }
            callback({ mensajes, respuesta });
        });
    }
    ObtenerBodegas(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal) {
          bodega {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: 1}}) {
              respuesta {
                registros {
                  nombre
                  codigo
                  descripcion
                  sucursal_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.bodega.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
BodegaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BodegaService_Factory() { return new BodegaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: BodegaService, providedIn: "root" });
